import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import TaskIcon from "@mui/icons-material/Task";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import SchoolIcon from "@mui/icons-material/School";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff";
import React, { useContext, useEffect, useState } from "react";
import "../../../styles/Layout/Admin_Styles/_DownloadData.scss";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";
import AdminTable from "../AdminTable/AdminTable";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HowToRegIcon from "@mui/icons-material/HowToReg";

const TableHeadData = [
  // { id: "request_type", label: "Title", alignItems: "left" },
  // {
  //   id: "createdAt",
  //   label: "Date",
  //   date: true,
  //   format: "MMM dd, yyyy (hh:mm:ss a)",
  //   isTime: true,
  //   alignItems: "left",
  // },
  { id: "title", label: "Title", alignItems: "left" },
  {
    id: "file_name",
    label: "File",
    text: true,
    linkLabel: "Download",
    link: true,
    type: "link",
  },
  { id: "req_status", label: "Status", alignItems: "left", status: true },
];

const cards = [
  {
    title: "Candidate Admit Card Data",
    icon: <TaskIcon className="download-icon-custom" />,
    group_type: "candidateAdmitCardData",
    btns: [
      {
        title: "Generate",
        fileTitle: "Candidate Admit Card Data",
        apiKey: "CandiateAdmitCardData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  {
    title: "Admit Card - Roll List",
    icon: <TaskIcon className="download-icon-custom" />,
    group_type: "admitcardRollNoData",
    btns: [
      {
        title: "Generate",
        fileTitle: "Admit Card - Roll List",
        apiKey: "AdmitCardRollNoData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  {
    title: "Admit Card - Desk Slip",
    icon: <TaskIcon className="download-icon-custom" />,
    group_type: "deskSlipData",
    btns: [
      {
        title: "Generate",
        fileTitle: "Admit Card - Desk Slip",
        apiKey: "DeskSlipData",
        path: apisPath?.admin?.downloadCandidateData,
      },
    ],
  },
  // {
  //   title: "Cancelled Application Data",
  //   icon: <ContentPasteOffIcon className="download-icon-custom" />,
  //   group_type: "CancelledData",
  //   btns: [
  //     {
  //       title: "Generate",
  //       apiKey: "CancelledData",
  //       fileTitle: "Candidates Data",
  //       path: apisPath?.admin?.downloadCandidateData,
  //     },
  //   ],
  // },
  // {
  //   title: "Education Completed Data",
  //   icon: <SchoolIcon className="download-icon-custom" />,
  //   education: "true",
  //   group_type: "educationCompletedData",
  //   btns: [
  //     {
  //       title: "Generate",
  //       apiKey: "educationPaidData",
  //       path: apisPath?.admin?.downloadEducationData,
  //     },
  //     {
  //       title: "Generate",
  //       fileTitle: "Candidates Data",
  //       apiKey: "educationPaidDataRowWise",
  //       path: apisPath?.admin?.downloadEducationDataRowWise,
  //     },
  //   ],
  // },
  {
    title: "Result Processing Data",
    icon: <HowToRegIcon className="download-icon-custom" />,
    group_type: "resultProcessing",
    btns: [
      {
        title: "Generate (Completed Data + Admit Card + Barcode)",
        fileTitle: "Completed Data + Admit Card + Barcode",
        apiKey: "completedAdmitCardBarcodeData",
        path: apisPath?.admin?.downloadEducationDataRowWise,
      },
      {
        title: "Generate (Education + Barcode)",
        fileTitle: "Education + Barcode",
        apiKey: "educationPaidBarcodeDataRowWise",
        path: apisPath?.admin?.downloadEducationDataRowWise,
      },
    ],
  },
];

function DownloadData() {
  const { setIsLoading, setAlertState, setIsTableLoading } =
    useContext(AuthContext);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    totalRecord: 0,
    rowsPerPage: 10,
  });

  const [expanded, setExpanded] = React.useState(cards[0]?.group_type);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      setIsTableLoading(true);
      setPaginationData((prev) => ({
        ...prev,
        currentPage: 0,
      }));
      getTableData(0, panel);
    }
  };

  useEffect(() => {
    setIsTableLoading(true);
    getTableData(paginationData?.currentPage, expanded);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pageChangeHandler = (page) => {
    setIsTableLoading(true);
    getTableData(page + 1, expanded);
    setPaginationData((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const getTableData = (page, key) => {
    authHttp
      .post(apisPath?.admin?.downloadData + `?page=${page}`, {
        download_request: key,
      })
      .then((res) => {
        const tempData = res?.data?.data;
        tempData.forEach((req) => {
          if (String(req?.error) === "1") {
            req.req_status = "Something went wrong";
            req.className = "fail";
          } else {
            if (String(req?.status) === "1") {
              req.req_status = req?.request_type.includes("RowWise")
                ? "Completed"
                : "Completed";
              req.className = "success";
            } else {
              req.req_status = req?.request_type.includes("RowWise")
                ? "Proccessing"
                : "Proccessing";
              req.className = "proccess";
            }
          }
        });
        setTableData(tempData);
        setPaginationData((prev) => ({
          ...prev,
          totalRecord: res?.data?.totalCount,
          rowsPerPage: res?.data?.resultperpage,
        }));
        setIsTableLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title:
            err?.response?.data?.msg ||
            "Your request is still in processing. Please wait for sometime then refresh the page.",
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const handleOpen = (id, type) => {
    if (type === "link") {
      const file = tableData.filter((row) => row.file_name === id);
      // console.log(id, file)
      if (String(file[0]?.status) === "1" && String(file[0]?.error) === "0") {
        const link = document.createElement("a");
        link.href = file[0]?.file_name;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        setIsLoading(false);
        link.click();
      } else {
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: "No File Found!!",
          btnTxt: "CLOSE",
          status: "fail",
        }));
      }
    }
  };

  const downloadExcel = (key, path, title, group_type) => {
    setIsLoading(true);
    // console.log(url)
    authHttp
      .post(path, {
        download_request: key,
        title: title,
        group_type: group_type,
      })
      .then((res) => {
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: res?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
        }));
        setIsTableLoading(true);
        getTableData(0, expanded);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  return (
    <div className="download-data">
      <div className="download-data--header">
        <h2>Download Data</h2>
      </div>
      {cards.map((card) => (
        <div className="download-data--accordian">
          <Accordion
            expanded={expanded === card?.group_type}
            onChange={handleChange(card?.group_type)}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<ExpandMoreIcon />}
              className="download-data--accsummary"
            >
              <Typography className="download-data--header download-header--green">
                <h3>
                  {" "}
                  {card?.icon} {card?.title}
                </h3>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="dowmload-data-info">
                <div className="download-data-header">
                  <h2>Data Requests</h2>
                </div>
                <div className="download-data-btn">
                  {card?.btns.map((btn) => (
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() => {
                        downloadExcel(
                          btn?.apiKey,
                          btn?.path,
                          btn?.fileTitle,
                          card?.group_type
                        );
                      }}
                    >
                      {btn?.title}
                    </Button>
                  ))}
                </div>
              </div>

              <div className="download-data--table">
                <AdminTable
                  tableHead={TableHeadData}
                  pageChangeHandler={pageChangeHandler}
                  data={tableData}
                  paginationData={paginationData}
                  handleOpen={handleOpen}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </div>
  );
}

export default DownloadData;
